<div class="library-tree-container">
	<mat-tree [dataSource]="dataSource"
			  [levelAccessor]="dataSource.levelAccessor"
			  [trackBy]="trackNode"
			  role="tree"
			  [attr.aria-label]="'library-tree-viewer_list-label' | translate">

		<mat-tree-node *matTreeNodeDef="let node"
					   role="treeitem"
					   [isExpandable]="node.expandable"
					   [isExpanded]="dataSource.isExpanded(node)"
					   (expandedChange)="handleExpandedChange(node, $event)"
					   [attr.aria-level]="node.level + 1">

			@if (node.type === 'folder') {
				<ngx-collection-folder-viewer
					[nodeLevel]="node.level"
					[useTreeView]="true"
					[folder]="node.data"
					[mode]="mode"
					[collections]="collections"
					[archiveCollection]="archiveCollection"
					[selectedCollection]="selectedCollection"
					[selectedContentType]="selectedContentType"
					[orgSettings]="orgSettings"
					[sortBy]="sortBy"
					[searchStr]="searchStr"
					[multiSelect]="multiSelect"
					[expandedHeight]="expandedHeight"
					[currentlySelected]="currentlySelected"
					(selectItem)="handleSelectItem($event)"
					(setActivityPanelIsOpen)="setActivityPanelIsOpen.emit($event)"
					(setCurrentlySelected)="setCurrentlySelected.emit($event)"
					(setSelectAllChecked)="setSelectAllChecked.emit($event)">
				</ngx-collection-folder-viewer>

				@if (isFolderEmpty(node)) {
					<div class="tree-folder-empty-state">
						<span>{{'collection-folder-no-items' | translate}}</span>
					</div>
				}
			} @else if (node.type === 'item') {
				<ngx-collection-item-viewer
					[useTreeView]="true"
					[node]="node"
					[nodeLevel]="node.level"
					[item]="node.data"
					[mode]="mode"
					[collections]="collections"
					[orgSettings]="orgSettings"
					[archiveCollection]="archiveCollection"
					[selectedCollection]="selectedCollection"
					[selectedContentType]="selectedContentType"
					[multiSelect]="multiSelect"
					[expandedHeight]="expandedHeight"
					[currentlySelected]="currentlySelected"
					(setActivityPanelIsOpen)="setActivityPanelIsOpen.emit($event)"
					(setCurrentlySelected)="setCurrentlySelected.emit($event)"
					(selectItem)="handleSelectItem($event)"
					(loadNewItems)="loadNewItems.emit($event)"
					(setSelectAllChecked)="setSelectAllChecked.emit($event)">
				</ngx-collection-item-viewer>
			}
		</mat-tree-node>
	</mat-tree>
</div>
